import { render, staticRenderFns } from "./TableNewstaff.vue?vue&type=template&id=1b317631&scoped=true"
import script from "./TableNewstaff.vue?vue&type=script&lang=js"
export * from "./TableNewstaff.vue?vue&type=script&lang=js"
import style0 from "./TableNewstaff.vue?vue&type=style&index=0&id=1b317631&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b317631",
  null
  
)

export default component.exports